import http from '@/api/common'

export default {
  addInsurance(data) {
    return http.get(`maintenance/SaveInsurance?name=${data}`)
  },
  getWorkOrderMaintenance(workOrder) {
    return http.get('maintenance/GetWorkOrder', {
      params: { workOrder }
    })
  },
  saveWorkOrderMaintenance(data) {
    return http.post('maintenance/SaveWorkOrder', data)
  },
  fixDispatchTimes() {
    return http.get('maintenance/FixDispatchTimes')
  },
  cancelPendingRequests(location) {
    return http.get('maintenance/CancelPendingRequests', {
      params: { location }
    })
  },
  searchTechnicians(searchTerm) {
    return http.get(`maintenance/SearchTechnicians/?search=${searchTerm}`)
  },
  resetTechnician(data) {
    return http.post('maintenance/ResetTechnician', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/maintenance.js